import { company } from '../config/company';
import './Footer.css';

function Footer() {
  return (
    <footer className="footer">
      <div className="container footer__inner">
        <div>
          <p className="footer__company">{company.name}</p>
          <p className="footer__slogan">{company.slogan}</p>
        </div>
        <p className="footer__address">
          {company.address.line1}, {company.address.line2},{' '}
          {company.address.line3}
        </p>
      </div>
      <p className="footer__copyright">
        © 2026 {company.name}. All rights reserved.
      </p>
    </footer>
  );
}

export default Footer;
